import { Modal } from "@twinkltech/curriculum-architect-component-library";
import { useUnitPreview } from "@twinkltech/curriculum-architect-domain-hooks";

import { LoadingModal } from "@/pages/LoadingModal/LoadingModal";

import { PreviewUnitModal } from "./PreviewUnitModal";

export const PreviewUnitModalContainer = ({
  onClose,
  unitId,
  ...props
}: {
  unitId: string;
} & Omit<React.ComponentProps<typeof Modal>, "children">) => {
  const { data, error, isLoading } = useUnitPreview({
    id: unitId,
  });

  if (isLoading) {
    return (
      <LoadingModal
        open
        className="px-4 py-2"
        width="md"
        onClose={() => onClose(false)}
      />
    );
  } else {
    return (
      <PreviewUnitModal
        error={error}
        isLoading={isLoading}
        unit={data}
        unitId={unitId}
        onClose={onClose}
        {...props}
      />
    );
  }
};
